import { render, staticRenderFns } from "./_featured.vue?vue&type=template&id=c81fa418"
import script from "./_featured.vue?vue&type=script&lang=js"
export * from "./_featured.vue?vue&type=script&lang=js"
import style0 from "./_featured.vue?vue&type=style&index=0&id=c81fa418&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports